import { post,postQustion } from './http.js';
import axios from 'axios'
let qs = require('qs')//引入qs模块
import { Message } from 'element-ui';
const XLX_URL = 'http://xlx.yunmeo.com:8084/'

const GS_URL = 'http://gs.yunmeo.com:8083/'

/**
 * 根据业主查询来点
 * query 手机号码
 */
export const selectOneByPhoneOrTel = phone_num => post(`/api/person/selectOneByPhoneOrTel?phone_num=${phone_num}`);

/**
 * 工单操作->增-工单
 */
export const workOrderCreate = (
	o_com_id,
	o_dept_id,
	o_lat,
	o_lng,
	o_q_img,
	o_src,
	o_type,
	o_zx_id,
	p_id,
	p_name,
	p_phone,
	p_sex,
	p_type,
	q_id,
	q_name,
	q_name_des,
	r_address,
	r_id,
	is_urgent
) => {
    if (!o_com_id || o_com_id=='' || !o_com_id.length){
    	o_com_id = '';
    }
    if (!o_dept_id || o_dept_id=='' || !o_dept_id.length){
    	o_dept_id = '';
    }
	const baseUrl = `/api/work_order/create?o_com_id=${o_com_id}&o_dept_id=${o_dept_id}&o_lat=${o_lat}&o_lng=${o_lng}&o_q_img=${o_q_img}&o_src=${o_src}&o_type=${o_type}&o_zx_id=${o_zx_id}&p_id=${p_id}&p_name=${p_name}&p_phone=${p_phone}&p_sex=${p_sex}&p_type=${p_type}&q_id=${q_id}&q_name=${q_name}&q_name_des=${q_name_des}&r_address=${r_address}&r_id=${r_id}&is_urgent=${is_urgent}`;
	
	
	return post(baseUrl);
}


function checkStatus(res) {

	if(res.status != '1') {
		//Message.error(res.msg);
		return false;
	}
	return res.data;
}


//查-用户-详情-根据token
export const selectUserByToken = (token) => post(`/api/user/selectDetailsByToken?token=${token}`);


/**
 * 问题操作->查询全部问题列表
 */

// export const questionAll = function (params){
//   return new Promise((resolve, reject) => {
//      try {
//      	 axios({
//            method:"post",
//            url:"/api/question/selectAllByXX",
//            data: {
//              q_type: '1'
//            },
//             headers: {
//                 'Content-Type': 'application/json;charset=UTF-8'
//             }
//        }).then(res => {
//          resolve(res);
//        });
//      } catch(err){
//      		console.log(err)
//      }
//   });
// }

/**
 * 查-模糊-列表-小区名称-小区
 */
// export const selectListArea = () => post('/api/community/selectAllByXX').then(res => {
// 	return checkStatus(res)
// });

/**
 * 删-工单
 */
export const workOrderDel = id => post(`/api/work_order/deleteById?id=${id}`).then(res => res.status == '1');

/**
 * 根据ID 查-公司
 */
export const CompanySelectId = id => post(`/api/company/selectById?id=${id}`).then(res => {
	return checkStatus(res)
})

/**
 *  查-业主信息
 */
export const personSelect = id => post(`/api/person/selectById?id=${id}`).then(res => {
	return checkStatus(res)
});

/**
 *  查-服务人信息
 */
export const userSelect = id => post(`/api/user/selectById?id=${id}`)

/**
 *  查-工单详情
 */
export const workOrder = id => post(`/api/work_order/selectById?id=${id}`).then(res => {
	return checkStatus(res)
});

/**
 *  呼入记录
 */
export const mobileCache = ( pageNum, pageSize, mobile) => post(`/api/work_order/selectAllByPhone?pageNum=${pageNum}&pageSize=${pageSize}&p_phone=${mobile}`)

/**
 *  查-列表-关键字-分页-工单
 */
export const seachWorks = (keyWord, o_status, pageNum, pageSize) => post(`/api/work_order/selectListByKeyWordByPage?keyWord=${keyWord}&o_status=${o_status}&pageNum=${pageNum}&pageSize=${pageSize}`);

/**
 *  查询所有公司
 *  c_pid : 1 热力
 *          2 物业
 */
export const companyAll = (c_pid) => post(`/api/company/selectAllByXX?c_pid=${c_pid}`).then( res => {
	return checkStatus(res)
});


/**
 *  查询所有部门
 * p_com_id 根据 公司ID
 */
export const deptAll = (p_com_id) => post(`/api/dept/selectAllByXX?p_com_id=${p_com_id}`).then( res => {
	return checkStatus(res)
});

/**
 *  换热站区域统计 1热力 2物业
 */
export const serviceCharts = (p_type) => post(`/api/work_order/selectCountDayGroupDeptId?p_type=${p_type}`).then( res => {
  return checkStatus(res)
})

// 查询小区 条件
export const selectAreaList = function (params) {
 return  axios.post('/api/community/selectAllByXX', params,
    {headers:{'Content-Type':'application/json'}}
  )
};

// 自动选择部门
export const selectDeptOptions = function (params) {
  return axios.post('/api/dept/selectAllByXX', params,  {headers:{'Content-Type':'application/json'}})
}

// 客服评价
export const updateEvaluate = (content, num, o_id, kf_id) => post(`/api/work_order/kf/updateEvaluate?o_evaluate_content=${content}&o_evaluate_level=${num}&o_id=${o_id}&u_kf_id=${kf_id}`)


// 自动选择公司
export const selectCompanyOptions = function (params) {
  return axios.post('/api/company/selectAllByXX', params,  {headers:{'Content-Type':'application/json'}})
}


// 问题分类
export const selectQuestionOptions = function (params) {
  return axios.post('/api/question/selectAllByXX', params,  {headers:{'Content-Type':'application/json'}})
}

// 新闻列表
export const newsList = function ( pageNum, params) {
  return axios.post(`api_p/news/selectAllByXXByPage?pageNum=${pageNum}&pageSize=10`, params,  {headers:{'Content-Type':'application/json'}})
}


// 删除新闻
export const newsDelete = (id) => post(`/api/news/deleteById?id=${id}`);

// 资讯类型
export const newsSelectALl = () => post('/api/news_type/selectAll');

// 增加新闻列表
export const newsAdd= function (  params) {
  return axios.post('/api/news/insert', params,  {headers:{'Content-Type':'application/json'}})
}

// 修改新闻列表
export const newsUpdate= function (  params) {
  return axios.post('/api/news/updateById', params,  {headers:{'Content-Type':'application/json'}})
}

/**
 * 查-列表-分页-用户
 * @param params
 * @returns {any}
 */
export const userSelectAllPage = function (pageNum, params) {
  return axios.post(`/api/user/selectAllByPage?pageNum=${pageNum}&pageSize=10`, params,  {headers:{'Content-Type':'application/json'}})
}

/**
 * 增-用户
 * @param params
 * @returns {any}
 */
export const userInert = function (params) {
  return axios.post(`/api/user/insert`, params,  {headers:{'Content-Type':'application/json'}})
}

/**
 * 删除-用户
 * @param params
 * @returns {any}
 */
export const userDelete = function (id) {
  return axios.post(`/api/user/deleteById?id=${id}`)
}

/**
 * 	修改一个用户
 */
export const userbyUpdate = function (params) {
	return axios.post('/api/user/updateById', params, {headers:{'Content-Type':'application/json'}} )
}

/**
 *  全部用户
 * @param id
 * @returns {any}
 */
export const userSelectAll = function () {
  return axios.post(`/api/user/selectAll`)
}

/**
 * 	POST查-列表-关键字-分页-用户
 */
export const searchNameByUser = (keyWord, pageNum, pageSize) => post(`/api/user/selectListByKeyWordByPage?keyWord=${keyWord}&pageNum=${pageNum}&pageSize=${pageSize}`);

/**
 *	改分配工单 
 */
export const updateAllot = function (o_id,o_zx_id,o_com_id,o_dept_id){
	return axios.post(`/api/work_order/zx/updateAllot?o_id=${o_id}&o_zx_id=${o_zx_id}&o_com_id=${o_com_id}&o_dept_id=${o_dept_id}`);
}

/**
 * 查-统计-部门工单统计-根据所属系统
 */
export const selectCountDayGroupDeptIdAndDateType = function(){
	return axios.post(`${XLX_URL}api_data_view/work_order/selectCountDayGroupDeptIdAndDateType`);
}

//查-工单报表-今日排行下载
export const selectListRanking = () => {
	return axios.post(`${XLX_URL}api_p/dept/selectListRanking`);
}

//查-工单报表/下载
export const selectListByWorkOrderReq = (pageNum, params, is_download, pageSize='10') => {

	if ( params.p_dept_id == '' ){
		params.p_dept_id = null
	}
	if (params.actual_dept_id == ''){
		params.actual_dept_id = null
	}
	if ( params.create_time_end == '' ){
		params.create_time_end = null
	}
	if ( params.create_time_start == '' ){
		params.create_time_start = null
	}
	if ( params.is_urgent == '' ){
		params.is_urgent = null
	}
	if ( params.o_com_id == '' ){
		params.o_com_id = null
	}
	if ( params.o_src == '' ){
		params.o_src = null
	}
	if ( params.o_type == '' ){
		params.o_type = null
	}
	if ( params.p_type == '' ){
		params.p_type = null
	}
	if ( params.q_id == '' ){
		params.q_id = null
	}
	if ( params.p_phone == '' ){
		 params.p_phone = null
	}

	return axios.post(`${XLX_URL}api_p/work_order/selectListByWorkOrderReq?pageNum=${pageNum}&is_download=${is_download}&pageSize=${pageSize}`, params, {headers:{'Content-Type':'application/json'}});
}


// 新闻客户端列表
export const newsPersonClient = (pageNum,pageSize) => {
	return  axios.post(`/api/news_person/selectAllByPage?pageNum=${pageNum}&pageSize=${pageSize}`);
}

// 增加新闻客户端新闻
export const newsPersonClientAdd = (params) => {
	return axios.post(`/api/news_person/insert`, params,  {headers:{'Content-Type':'application/json'}});
}

// 查-工单状态-关键字-坐席端
export const selectListByKeyWordCondition = (params) => {
	console.log(params);
	return axios.post(`/api/work_order/zx/selectListByKeyWordCondition`, params);
}

//news_type_person/selectAll
// 查看新闻客户端新闻-分类
export const newsPersonClientTypeAll = () => {
	return axios.post(`/api/news_type_person/selectAll`);
}
// 查看新闻客户端新闻-删除
export const newsPersonClientDel = (id) => {
	return axios.post(`/api/news_person/deleteById?id=${id}`);
}
// 查看新闻客户端新闻-修改
export const newsPersonClientUpdate = (params) => {
	return axios.post(`/api/news_person/updateById`, params,{headers:{'Content-Type':'application/json'}});
}

// 上传12345工单
export const upload12345 = (file) => {
	return axios.post(`/api/work_order/upload12345`, file,  {headers:{'Content-Type':'application/json'}});
}

// 查询用户-部门-根据前缀
export const selectOneByDeptIdAndUsername = (p_dept_id,start_with) => {
	return axios.post(`/api_p/user/selectOneByDeptIdAndUsername?p_dept_id=${p_dept_id}&start_with=${start_with}`);
}

/**
 * 查-列表-分页-部门
 */
export const selectDeptPage = ( pageNum, pageSize ) => post(`/api/dept/selectAllByPage?pageNum=${pageNum}&pageSize=${pageSize}`);

/**
 * 查-列表-全部-部门
 */
export const selectDeptPageAll = ( pageNum, pageSize ) => post('/api/dept/selectAll');
/**
 * 查-部门
 * @param {*} id 
 */
export const selectDeptById = function(id){
	return axios.post(`/api/dept/selectById?id=${id}`)
}

/**
 * 	app上传列表
 */
export const appManager = function(){
	return axios.post('/api/app_manager/selectAll')
}


/**
 * 	app上传列表苹果
 */
export const appManagerIos = function (){
	return axios.post('/api/ios_manager/selectAll');
}

///api/ios_manager/insert
/**
 *  增-ios版本管理
 */
export const insertIosApp = function ( params ){
	return axios.post('api/ios_manager/insert', params, {headers:{'Content-Type':'application/json'}});
}

/**
 * 	app上传列表 删除
 */
export const appManagerDel = function(id){
	return axios.post(`/api/app_manager/deleteById?id=${id}`)
}


/**
 * 	app上传列表 删除
 */
export const appManagerDelIos = function (id){
	return axios.post(`/api/ios_manager/deleteById?id=${id}`);
}

/**
 * 	待分配工单
 */
export const awaitOrder = function (param){
	return axios.post('/api/work_order/zx/selectListWaitAllot'+param);
}
//查-新闻资讯-业主
export const newsPersonInfo = function (id){
	return axios.post('/api/news_person/selectById?id='+id);
}

/**
 * 查-列表-条件-部门
 * @param {*} params 
 */
export const deptAllByXX = function (  ){
	return axios.post('/api/dept/selectAllByXX', {}, {headers:{'Content-Type':'application/json'}});
}
/**
 * 增-部门
 * @param {*} param 
 */
export const deptInsert = function (param) {
	return axios.post('/api/dept/insert', param, {headers:{'Content-Type':'application/json'}});
}

/**
 * 改-部门
 * @param {*} param 
 */
export const deptUpdate = function (param) {
	return axios.post('/api/dept/updateById', param, {headers:{'Content-Type':'application/json'}});
}
/**
 * 删-部门
 * @param {*} param 
 */
export const deptDelete = function (id) {
	return axios.post('/api/dept/deleteById?id='+id);
}
// /api/dept/deleteById
/**
 * 查-列表-条件-分页-部门
 * @param {*} param 
 */
export const deptSelectPage = function (pageNum,pageSize) {
	return axios.post(`/api/dept/selectAllByXXByPage?pageNum=${pageNum}&pageSize=${pageSize}`, {}, {headers:{'Content-Type':'application/json'}});
}


// WEBPACK FOOTER //
// ./src/api/api.js